import GS from '../grafsync/grafsync';
import Notification from '../core/Notification';
import withGS from '../core/withGShoc';
import DataOptions from '../core/DataOptions';
import Grid from '@material-ui/core/Grid';
import AssociatedProjectDisplay from './AssociatedProjectDisplay';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from '../core/style/gstheme';
import TripleViewer from '../core/TripleViewer';
import HistoryViewer from '../core/HistoryViewer';
import ResourceSummaryDetail from '../ontology/ResourceSummaryDetail';

const styles = Object.assign({}, globalStyles);

class StatementData extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            view: 0
        };
    }

    changeView = (index) => this.setState({ view: index });

    addNewTypedLiteral = (property, propertyGraphIRI) => (value, datatype = null) => {
        GS.addProperty(this.props.id, this.props.graph, property, value, null, datatype, propertyGraphIRI);
    };

    addNewLiteral = (property, propertyGraphIRI) => (language, text) => {
        GS.addProperty(this.props.id, this.props.graph, property, text, language, null, propertyGraphIRI);
    };

    onUpdate = (property, lang, index, propertyGraphIRI) => (value) => {
        this.props.onUpdate(property, value, lang, index, propertyGraphIRI);
    };

    deleteStatement = () => GS.deleteResource(this.props.id, this.props.graph);

    removeLabel = (property, language, value) => GS.deleteProperty(this.props.id, this.props.graph, property, value, language);

    onDelete = (property, lang, datatype, propertyGraphIRI) => (value) =>
        this.props.onDelete(property, value, lang, datatype, propertyGraphIRI);

    onAddClass = async (value) => this.props.onAdd("type", value);

    includeExistingResource = (property, propertyGraphIRI) => async (newIRI) => {
        const { graph, id } = this.props;
        // We load the concept we are about to use to make sure rendering works okay
        // But if it's external it won't load and that's okay
        GS.loadData([newIRI], {}, graph, true).then(() => {
            GS.addProperty(id, graph, property, newIRI, null, null, propertyGraphIRI);
        });
    };

    render() {

        const { isReadOnly, defaultLang, projectLang, linkedData, ontologyProjectAssociation,
            viewLang, graph, propertyTemplates, projectType, property, requiredEntitlement,
            projectIRI, componentIRI, useWorkflow, associatedTaxonomyProject, dialogComponent,
            components, data, id } = this.props;
        const { view } = this.state;

        const readOnly = isReadOnly || data.pendingDeletion === true || data.deprecated === true;

        let resourceClasses = Array.isArray(data.type) ? data.type : [data.type];
        // Some of the classes may be aliased so convert to IRIs
        resourceClasses = resourceClasses.map(rc => GS.getIRIfromAlias(rc) || rc);

        return (
            <div
                style={{ display: 'flex' }}
            >
                <div style={{ marginTop: 40 }}>
                    <DataOptions
                        handleNotAvailable={true}
                        useWorkflow={false}
                        historyOption={true}
                        changeView={this.changeView}
                        view={view}
                        id={id}
                        graph={graph}
                    />
                </div>
                <div style={{ width: 'calc(100% - 60px)', paddingLeft: '10px' }}>
                    <ResourceSummaryDetail
                        ariaLabel="Annotation resource summary detail"
                        handleNotAvailable={true}
                        project={projectIRI}
                        suppressLabel={true}
                        useWorkflow={false}
                        allowIRIchange={false}
                        isReadOnly={isReadOnly}
                        graph={graph}
                        defaultLang={defaultLang}
                        id={id}
                        viewLang={viewLang}
                        canDeprecate={true}
                        onDeleteResource={this.deleteStatement}
                        permission={requiredEntitlement} />
                    {data.pendingDeletion &&
                        <Notification error={true} text="This annotation is pending deletion." dataTest="pending-deletion" />
                    }
                    {data.deprecated &&
                        <Notification text="This annotation is deprecated." dataTest="deprecated" />
                    }
                    {view === 0 && ontologyProjectAssociation &&
                        <Grid container spacing={1}>
                            {[...ontologyProjectAssociation].sort().map((opa) =>
                                <AssociatedProjectDisplay
                                    resourceData={data}
                                    graph={graph}
                                    dialogComponent={dialogComponent}
                                    forceBaseClass={true}
                                    baseInferredClass="http://www.w3.org/1999/02/22-rdf-syntax-ns#Statement"
                                    projectIRI={projectIRI}
                                    schemeIRI={componentIRI}
                                    useWorkflow={useWorkflow}
                                    reify={false}
                                    global={false}
                                    suppress={
                                        [
                                            "Symmetric",
                                            "Inverse"
                                        ]
                                    }
                                    filterTemplatesByProperty={property}
                                    propertyTemplates={propertyTemplates}
                                    isReadOnly={readOnly}
                                    viewLang={viewLang}
                                    projectLang={projectLang}
                                    projectType={projectType}
                                    linkedData={linkedData}
                                    associatedTaxonomyProject={associatedTaxonomyProject}
                                    addNewLiteral={this.addNewLiteral}
                                    addNewTypedLiteral={this.addNewTypedLiteral}
                                    includeExistingResource={this.includeExistingResource}
                                    components={components}
                                    resourceClasses={resourceClasses}
                                    onDelete={this.onDelete}
                                    onUpdate={this.onUpdate}
                                    key={opa}
                                    id={opa}
                                    defaultLang={defaultLang} />
                            )}
                        </Grid>
                    }
                    {view === 1 &&
                        <TripleViewer
                            handleNotAvailable={true}
                            isReadOnly={true}
                            useWorkflow={false}
                            id={id}
                            graph={graph} />}
                    {view === 4 &&
                        <HistoryViewer
                            handleNotAvailable={true}
                            id={id}
                            graph={graph} />}
                </div>
            </div>
        );
    }
}

StatementData.propTypes = {
    requiredEntitlement: PropTypes.string.isRequired,
    projectIRI: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    associatedTaxonomyProject: PropTypes.array,
    showDialog: PropTypes.func,
    statements: PropTypes.array,
    componentIRI: PropTypes.string,
    classes: PropTypes.object
};

export default withStyles(styles)(withGS(StatementData, ["ALL"], null, {}, true));